import {createStyles, Theme} from "@material-ui/core";
import {beigeColor, typography} from "src/main.style";

export const OnboardingStyle = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        position: 'relative',

        '& > *': {
            boxSizing: "border-box",
        },
    },
    background: {
        boxSizing: 'content-box',
        position: 'fixed',
        overflow: 'hidden',
        top: 0,
        left: 0,
        width: '100vw',
        minWidth: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        minHeight: '100vh',
        maxHeight: '100vh',
        zIndex: -1,
        backgroundColor: theme.palette.background.default,
    },
    circle: {
        zIndex: 0,
        position: 'absolute',
        top: '20rem',
        left: '-1.75rem',
        width: '56.25rem',
        height: '56.25rem',
        borderRadius: '56.25rem',
        backgroundColor: beigeColor,

        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    container: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(6.25),
    },
    topBar: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(2.5),
        marginBottom: theme.spacing(2.5),
    },
    topBarWithBackButton: {
        marginBottom: 0,
    },
    backButton: {
        padding: theme.spacing(1.25, 0),
        textTransform: 'uppercase',
    },
    topContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(2.5),
    },
    middleContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(2.5),
    },
    bottomContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        alignItems: 'center',
        marginTop: theme.spacing(2.5),
    },
    form: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
    },
    formMiddleContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
    },
    formBottomContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2.5),
    },
    label: {
        ...typography.label,
    },
    errorMessage: {
        ...typography.feedback,
        color: theme.palette.error.main,
    },
  });



// WEBPACK FOOTER //
// ./src/components/onboarding/onboarding.style.ts